<template>
  <table class="text-center border-table">
    <tr>
      <th class="w-2">{{$t('views.exsbdocument.show.documentPosition.lp')}}</th>
      <th class="w-5"></th>
      <th>{{$t('views.exsbdocument.show.documentPosition.item')}}</th>
      <th>{{$t('views.exsbdocument.show.documentPosition.quantity')}}</th>
      <th>{{$t('views.exsbdocument.show.documentPosition.measure')}}</th>
      <th>{{$t('views.exsbdocument.show.documentPosition.pricePerUnitNetto')}}</th>
      <th>{{$t('views.exsbdocument.show.documentPosition.vatRate')}}</th>
      <th>{{$t('views.exsbdocument.show.documentPosition.pricePerUnitBrutto')}}</th>
    </tr>
    <tr v-for="(position, index) in positions" v-bind:key="index">
      <td>{{ index + 1 }}</td>
      <td>
        <div :id="'image_'+index" class="float-right picturebox" style="max-height: 35px; max-width: 35px">
          <b-img style="object-fit: fill;" :src="getPicturePreview(position)" alt="picture"/>
          <b-tooltip :target="'image_'+index">
            <b-img :src="getPicturePreview(position)" alt="picture"/>
          </b-tooltip>
        </div>
      </td>
      <td>
        {{ position.item.name }}
      </td>
      <td>{{ position.quantity }}</td>
      <td>{{ position.measure.name }}</td>
      <td>{{ position.pricePerUnitNetto }}</td>
      <td>{{ position.vatRate.range }}</td>
      <td>{{ position.pricePerUnitBrutto }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'PositionsTable',

  props: ['positions'],

  methods: {
    getPicturePreview (position) {
      let defaultPicturePreview = '/static/img/no-image.png'
      return position.item.picturePreview || defaultPicturePreview
    }
  }
}
</script>

<style scoped>

</style>
